export default __webpack_public_path__ + "static/media/coming-soon-bg.63352f07.jpg";